import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3024be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }

import {
  RequestIcon,
  CustomElement,
  EventString,
  EventIcon,
  IconAlternatives,
  RequestString,
  RequestStringIcon,
  EventStringIcon,
  Classes,
  StringIcon,
  SubElements,
} from "@/types";
import {
  getBreakpoint,
  updateBreakpointClasses,
  getCssColor,
  getIonicColor,
  getLocale,
  getCurrentElement,
  dateStringToISODate,
  toDateString,
  getIcon,
} from "@/utils";
import {
  IonCheckbox,
  IonButton,
  IonLabel,
  IonIcon,
  IonItem,
  IonInput,
  DatetimeCustomEvent,
  IonDatetime,
  IonDatetimeButton,
  IonModal,
} from "@ionic/vue";
import {
  computed,
  ComputedRef,
  nextTick,
  onBeforeUnmount,
  onMounted,
  PropType,
  reactive,
  ref,
  watch,
} from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'IonicElement',
  props: {
  element: {
    type: Object as PropType<CustomElement>,
    required: true,
  },
  disabled: Boolean, //<!-- TODO (7): aggiornare posti dove viene usato
},
  emits: ["execute_link", "signal_event", "update:element"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "06de70d0": (_unref(css_text_color)),
  "0ef57e5e": (_unref(css_background_color)),
  "69fe2f8c": (_unref(css_borders_color)),
  "9530673c": (_unref(border_radius)),
  "3250f9b8": (_unref(css_placeholder_color)),
  "5dd88120": (_unref(css_placeholder_opacity))
}))

const castInputValue = (a: any) => a as string | number;
const castCheckboxValue = (a: any) => a as boolean;
const castIconAlternatives = (a: any) => a as IconAlternatives;
const castStringIcon = (a: any) => a as StringIcon;
const castRequestIcon = (a: any) => a as RequestIcon;
const castEventIcon = (a: any) => a as EventIcon;
const castRequestString = (a: any) => a as RequestString;
const castEventString = (a: any) => a as EventString;
const castRequestStringIcon = (a: any) => a as RequestStringIcon;
const castEventStringIcon = (a: any) => a as EventStringIcon;

const updateElementClasses = () => {
  for (const sub_element in actual_classes) {
    updateBreakpointClasses(
      props.element.classes?.[sub_element as SubElements],
      actual_classes[sub_element as SubElements] as {
        [key: string]: boolean;
      },
      breakpoint.value
    );
  }
};
const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);

  updateElementClasses();
};
const changeDate = (event: DatetimeCustomEvent) => {
  const tmp_str_date = event.target.value;

  let tmp_date: Date;

  if (typeof tmp_str_date == "string") {
    tmp_date = new Date(tmp_str_date);

    if (actual_max_date == undefined || tmp_date <= new Date(actual_max_date)) {
      element_ref.value.content = toDateString(tmp_date);
    } else {
      element_ref.value.content = "";
    }
  } else {
    element_ref.value.content = "";
  }
  emit("update:element", props.element);
  store.state.event = {
    event: "ion-input",
    data: {
      element_ref: props.element.params?.ref ?? props.element.id,
    },
  };
  emit("signal_event");
};
const togglePassword = () => {
  if (element_ref.value.params == undefined) {
    element_ref.value.params = {};
  }
  show_password.value = +!show_password.value;
};

const store = useStore();



const css_text_color =
  props.element.colors?.text != undefined
    ? getCssColor(props.element.colors.text)
    : undefined; // label per input
const css_background_color =
  props.element.colors?.background != undefined
    ? getCssColor(props.element.colors.background)
    : undefined;
const css_borders_color =
  props.element.colors?.borders != undefined
    ? getCssColor(props.element.colors.borders)
    : undefined;
const css_placeholder_color =
  props.element.colors?.placeholder != undefined
    ? getCssColor(props.element.colors.placeholder, false)
    : undefined;
const default_low_opacity = 0.8;
const css_placeholder_opacity =
  props.element.colors?.placeholder?.alpha ?? default_low_opacity;
const css_checkmark_color =
  props.element.colors?.checkmark != undefined
    ? getCssColor(props.element.colors.checkmark)
    : undefined;
const css_background_checked_color =
  props.element.colors?.background_checked != undefined
    ? getCssColor(props.element.colors.background_checked)
    : undefined;
const css_borders_checked_color =
  props.element.colors?.borders_checked != undefined
    ? getCssColor(props.element.colors.borders_checked)
    : undefined;

const border_radius = props.element.params?.border_radius ?? "0px";

const breakpoint = ref(getBreakpoint(window.innerWidth));

const actual_classes: Classes<SubElements, boolean> = reactive({
  label: {
    textColor: props.element.colors?.text != undefined,
    backgroundColor: css_background_color != undefined,
    borders: css_borders_color != undefined,
  },
  html: {
    textColor: props.element.colors?.text != undefined,
    backgroundColor: css_background_color != undefined,
    borders: css_borders_color != undefined,
  },
  icon: {
    textColor:
      props.element.colors?.text != undefined &&
      props.element.params?.type != "password",
    backgroundColor:
      css_background_color != undefined &&
      props.element.params?.type != "password",
    borders:
      css_borders_color != undefined &&
      props.element.linkType == undefined &&
      props.element.params?.type != "password",
    backgroundIcon: props.element.params?.type == "password",
  },
  button: {
    customText: props.element.colors?.text != undefined,
    customBackground: css_background_color != undefined,
    customBorders: css_borders_color != undefined || border_radius != "0px",
  },
  item: {
    backgroundColor: css_background_color != undefined,
    borders: css_borders_color != undefined,
    "ion-no-padding": props.element.params?.type == "password",
  },
  input: {
    // <!-- TODO (5): mette le classi in props.element.classes?.input, ma non funzionano (anche checkbox)
    customText: props.element.colors?.text != undefined,
    customBackground: css_background_color != undefined,
    customBorders: css_borders_color != undefined || border_radius != "0px",
    placeholderColor:
      css_placeholder_color != undefined ||
      css_placeholder_opacity != default_low_opacity,
  },
  checkbox: {
    customBorders: css_borders_color != undefined || border_radius != "0px",
  },
});

const actual_label =
  typeof props.element.params?.label == "string"
    ? props.element.params.label
    : "";
const actual_input_placeholder =
  typeof props.element.params?.placeholder == "string"
    ? props.element.params.placeholder
    : "";
const actual_max_date: string =
  props.element.params?.max_date != undefined
    ? props.element.params.max_date
    : undefined;

const element_ref = ref(props.element);
const show_password = ref(0);
const eye_icons: {
  [key: number]: IconAlternatives;
} = {
  0: getIcon("eye"),
  1: getIcon("eyeOff"),
};

let date_ref: ComputedRef<string | undefined> | undefined = undefined;
if (props.element.type === "input_date") {
  date_ref = computed(() =>
    element_ref.value.content == ""
      ? undefined
      : dateStringToISODate(element_ref.value.content as string)
  );
}

updateElementClasses();
if (
  actual_classes.label != undefined ||
  actual_classes.html != undefined ||
  actual_classes.icon != undefined ||
  actual_classes.button != undefined ||
  actual_classes.item != undefined ||
  actual_classes.input != undefined ||
  actual_classes.checkbox != undefined
) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });
}

watch(
  () => props.element,
  (newValue) => {
    element_ref.value = newValue;
  }
);
watch(
  () => element_ref.value,
  (value) => emit("update:element", value)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.element.type == 'input_date')
      ? (_openBlock(), _createBlock(_unref(IonModal), {
          key: 0,
          "keep-contents-mounted": true
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonDatetime), {
              id: 'date_' + __props.element.id,
              onIonChange: changeDate,
              presentation: __props.element.params?.presentation,
              "first-day-of-week": 1,
              max: _unref(actual_max_date),
              "hour-cycle": "h23",
              locale: _unref(getLocale)(),
              "show-clear-button": __props.element.params?.show_clear_button ?? true,
              "clear-text": _unref(getCurrentElement)('clear'),
              value: _unref(date_ref)
            }, null, 8, ["id", "presentation", "max", "locale", "show-clear-button", "clear-text", "value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.element.type == 'html')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: __props.element.content,
          class: _normalizeClass(actual_classes.html)
        }, null, 10, _hoisted_1))
      : (__props.element.type == 'input' && __props.element.params?.type != 'password')
        ? (_openBlock(), _createBlock(_unref(IonInput), {
            key: 2,
            type: __props.element.params?.type ?? 'text',
            value: castInputValue(element_ref.value.content),
            disabled: __props.element.params?.disabled,
            label: _unref(actual_label),
            "aria-label": _unref(actual_label),
            placeholder: _unref(actual_input_placeholder),
            color: _unref(getIonicColor)(__props.element.colors?.text),
            size: __props.element.params?.size ?? 'default',
            fill: "outline",
            class: _normalizeClass(actual_classes.input),
            onIonInput: _cache[0] || (_cache[0] = 
      ($event) => {
        const tmp_element = __props.element;
        tmp_element.content =
          $event.target.value ?? (__props.element.params?.type == 'number' ? 0 : '');
        _ctx.$emit('update:element', tmp_element);
        _unref(store).state.event = {
          event: 'ion-input',
          data: {
            element_ref: __props.element.params?.ref ?? __props.element.id,
          },
        };
        _ctx.$emit('signal_event');
      }
    ),
            onKeydown: _cache[1] || (_cache[1] = ($event: any) => {
      _unref(store).state.event = {
        event: 'keydown',
        data: {
          element_ref: __props.element.params?.ref ?? __props.element.id,
          key_event: $event,
        },
      };
      _ctx.$emit('signal_event');
    })
          }, null, 8, ["type", "value", "disabled", "label", "aria-label", "placeholder", "color", "size", "class"]))
        : (__props.element.type == 'input' && __props.element.params?.type == 'password')
          ? (_openBlock(), _createBlock(_unref(IonItem), {
              key: 3,
              class: _normalizeClass(actual_classes.item),
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonInput), {
                  type: show_password.value ? 'text' : 'password',
                  value: castInputValue(element_ref.value.content),
                  disabled: __props.element.params?.disabled,
                  label: _unref(actual_label),
                  "aria-label": _unref(actual_label),
                  placeholder: _unref(actual_input_placeholder),
                  color: _unref(getIonicColor)(__props.element.colors?.text),
                  size: __props.element.params?.size ?? 'default',
                  fill: "outline",
                  class: _normalizeClass(actual_classes.input),
                  onIonInput: _cache[2] || (_cache[2] = 
        ($event) => {
          const tmp_element = __props.element;
          tmp_element.content =
            $event.target.value ?? (__props.element.params?.type == 'number' ? 0 : '');
          _ctx.$emit('update:element', tmp_element);
          _unref(store).state.event = {
            event: 'ion-input',
            data: {
              element_ref: __props.element.params?.ref ?? __props.element.id,
            },
          };
          _ctx.$emit('signal_event');
        }
      )
                }, null, 8, ["type", "value", "disabled", "label", "aria-label", "placeholder", "color", "size", "class"]),
                _createVNode(_unref(IonButton), {
                  slot: "end",
                  fill: "clear",
                  onClick: togglePassword,
                  class: _normalizeClass(actual_classes.button)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      ios: eye_icons[show_password.value].ios,
                      md: eye_icons[show_password.value].md,
                      class: _normalizeClass(actual_classes.icon)
                    }, null, 8, ["ios", "md", "class"])
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }, 8, ["class"]))
          : (__props.element.type == 'checkbox')
            ? (_openBlock(), _createBlock(_unref(IonCheckbox), {
                key: 4,
                disabled: __props.element.params?.disabled,
                checked: castCheckboxValue(element_ref.value.content),
                "aria-label": _unref(actual_label),
                class: _normalizeClass(actual_classes.checkbox),
                style: _normalizeStyle({
      '--checkmark-color': _unref(css_checkmark_color),
      '--checkbox-background': _unref(css_background_color),
      '--border-color-checked': _unref(css_borders_checked_color),
      '--checkbox-background-checked': _unref(css_background_checked_color),
    }),
                onIonChange: _cache[3] || (_cache[3] = 
      ($event) => {
        const tmp_element = __props.element;

        tmp_element.content = $event.target.checked ?? false;
        _ctx.$emit('update:element', tmp_element);
      }
    )
              }, null, 8, ["disabled", "checked", "aria-label", "class", "style"]))
            : (__props.element.linkType == undefined)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (__props.element.type == 'string' || __props.element.type == 'title')
                    ? (_openBlock(), _createBlock(_unref(IonLabel), {
                        key: 0,
                        color: _unref(getIonicColor)(__props.element.colors?.text),
                        class: _normalizeClass(actual_classes.label)
                      }, {
                        default: _withCtx(() => [
                          (__props.element.type == 'string')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(__props.element.content), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(__props.element.content), 1))
                        ]),
                        _: 1
                      }, 8, ["color", "class"]))
                    : (__props.element.type == 'icon')
                      ? (_openBlock(), _createBlock(_unref(IonIcon), {
                          key: 1,
                          ios: castIconAlternatives(__props.element.content).ios,
                          md: castIconAlternatives(__props.element.content).md,
                          color: _unref(getIonicColor)(__props.element.colors?.text),
                          class: _normalizeClass(actual_classes.icon)
                        }, null, 8, ["ios", "md", "color", "class"]))
                      : (__props.element.type == 'string_icon')
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 2,
                            lines: __props.element.colors?.borders != undefined ? 'inset' : 'none',
                            color: _unref(getIonicColor)(__props.element.colors?.background),
                            class: _normalizeClass(actual_classes.item)
                          }, {
                            default: _withCtx(() => [
                              (!castStringIcon(__props.element.content).order)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_unref(IonLabel), {
                                      color: _unref(getIonicColor)(__props.element.colors?.text),
                                      class: _normalizeClass(actual_classes.label)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(castStringIcon(__props.element.content).text), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color", "class"]),
                                    _createVNode(_unref(IonIcon), {
                                      ios: castStringIcon(__props.element.content).icon.ios,
                                      md: castStringIcon(__props.element.content).icon.md,
                                      color: _unref(getIonicColor)(__props.element.colors?.text),
                                      class: _normalizeClass(actual_classes.icon)
                                    }, null, 8, ["ios", "md", "color", "class"])
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_unref(IonIcon), {
                                      ios: castStringIcon(__props.element.content).icon.ios,
                                      md: castStringIcon(__props.element.content).icon.md,
                                      color: _unref(getIonicColor)(__props.element.colors?.text),
                                      class: _normalizeClass({
            'ion-padding-end': true,
            ...actual_classes.icon,
          })
                                    }, null, 8, ["ios", "md", "color", "class"]),
                                    _createVNode(_unref(IonLabel), {
                                      color: _unref(getIonicColor)(__props.element.colors?.text),
                                      class: _normalizeClass(actual_classes.label)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(castStringIcon(__props.element.content).text), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color", "class"])
                                  ], 64))
                            ]),
                            _: 1
                          }, 8, ["lines", "color", "class"]))
                        : _createCommentVNode("", true),
                  (__props.element.type == 'input_date')
                    ? (_openBlock(), _createBlock(_unref(IonItem), {
                        key: 3,
                        lines: "none",
                        style: {"width":"fit-content"},
                        class: "ion-no-padding"
                      }, {
                        default: _withCtx(() => [
                          (_unref(actual_label) != '')
                            ? (_openBlock(), _createBlock(_unref(IonLabel), {
                                key: 0,
                                "aria-label": _unref(actual_label),
                                color: "primary",
                                style: {"color":"var(--ion-color-primary)","width":"fit-content"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(actual_label)), 1)
                                ]),
                                _: 1
                              }, 8, ["aria-label"]))
                            : _createCommentVNode("", true),
                          _createVNode(_unref(IonDatetimeButton), {
                            datetime: 'date_' + __props.element.id,
                            style: {"width":"fit-content"},
                            class: "ion-padding-start"
                          }, null, 8, ["datetime"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                  (__props.element.type == 'string' || __props.element.type == 'title')
                    ? (_openBlock(), _createBlock(_unref(IonLabel), {
                        key: 0,
                        color: _unref(getIonicColor)(__props.element.colors?.text),
                        onClick: _cache[4] || (_cache[4] = 
        () => {
          if (!__props.disabled && __props.element.linkType == 'request') {
            _unref(store).state.request = {
              url: castRequestString(__props.element.content).url,
              method: castRequestString(__props.element.content).method,
            };
            _ctx.$emit('execute_link');
          } else if (!__props.disabled && __props.element.linkType == 'event') {
            _unref(store).state.event = {
              event: castEventString(props.element.content).event,
              data: castEventString(props.element.content).data,
            };
            _ctx.$emit('signal_event');
          }
        }
      ),
                        class: _normalizeClass(["clickable", actual_classes.label])
                      }, {
                        default: _withCtx(() => [
                          (__props.element.type == 'string')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(castEventString(__props.element.content).text), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(castEventString(__props.element.content).text), 1))
                        ]),
                        _: 1
                      }, 8, ["color", "class"]))
                    : (
        __props.element.type == 'icon' ||
        (__props.element.type == 'string_icon' &&
          castEventStringIcon(__props.element.content).whole_link)
      )
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 1,
                          disabled: __props.disabled,
                          fill: "clear",
                          onClick: _cache[5] || (_cache[5] = 
        () => {
          if (__props.element.linkType == 'request') {
            _unref(store).state.request = {
              url: (__props.element.type == 'icon'
                ? castRequestIcon(__props.element.content)
                : castRequestStringIcon(__props.element.content)
              ).url,
              method: (__props.element.type == 'icon'
                ? castRequestIcon(__props.element.content)
                : castRequestStringIcon(__props.element.content)
              ).method,
            };
            _ctx.$emit('execute_link');
          } else if (__props.element.linkType == 'event') {
            _unref(store).state.event = {
              event: (__props.element.type == 'icon'
                ? castEventIcon(__props.element.content)
                : castEventStringIcon(__props.element.content)
              ).event,
              data: (__props.element.type == 'icon'
                ? castEventIcon(__props.element.content)
                : castEventStringIcon(__props.element.content)
              ).data,
            };
            _ctx.$emit('signal_event');
          }
        }
      ),
                          class: _normalizeClass(actual_classes.button)
                        }, {
                          default: _withCtx(() => [
                            (
          __props.element.type == 'string_icon' &&
          (castStringIcon(__props.element.content).order == undefined ||
            !castStringIcon(__props.element.content).order)
        )
                              ? (_openBlock(), _createBlock(_unref(IonLabel), {
                                  key: 0,
                                  color: _unref(getIonicColor)(__props.element.colors?.text),
                                  class: _normalizeClass([actual_classes.label, "ion-padding-end"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(castStringIcon(__props.element.content).text), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color", "class"]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(IonIcon), {
                              ios: 
          (__props.element.type == 'icon'
            ? castEventIcon(__props.element.content)
            : castEventStringIcon(__props.element.content)
          ).icon.ios
        ,
                              md: 
          (__props.element.type == 'icon'
            ? castEventIcon(__props.element.content)
            : castEventStringIcon(__props.element.content)
          ).icon.md
        ,
                              color: _unref(getIonicColor)(__props.element.colors?.text),
                              class: _normalizeClass(actual_classes.icon)
                            }, null, 8, ["ios", "md", "color", "class"]),
                            (
          __props.element.type == 'string_icon' && castStringIcon(__props.element.content).order
        )
                              ? (_openBlock(), _createBlock(_unref(IonLabel), {
                                  key: 1,
                                  color: _unref(getIonicColor)(__props.element.colors?.text),
                                  class: _normalizeClass([actual_classes.label, "ion-padding-start"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(castStringIcon(__props.element.content).text), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color", "class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["disabled", "class"]))
                      : (__props.element.type == 'string_icon')
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 2,
                            lines: __props.element.colors?.borders != undefined ? 'inset' : 'none',
                            color: _unref(getIonicColor)(__props.element.colors?.background),
                            class: _normalizeClass(actual_classes.item)
                          }, {
                            default: _withCtx(() => [
                              (
          castStringIcon(__props.element.content).order == undefined ||
          !castStringIcon(__props.element.content).order
        )
                                ? (_openBlock(), _createBlock(_unref(IonLabel), {
                                    key: 0,
                                    color: _unref(getIonicColor)(__props.element.colors?.text),
                                    class: _normalizeClass({
          'ion-padding-end': true,
          ...actual_classes.label,
        })
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(castStringIcon(__props.element.content).text), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color", "class"]))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(IonButton), {
                                disabled: __props.disabled,
                                fill: "clear",
                                onClick: _cache[6] || (_cache[6] = 
          () => {
            if (__props.element.linkType == 'request') {
              _unref(store).state.request = {
                url: castRequestStringIcon(__props.element.content).url,
                method: castRequestStringIcon(__props.element.content).method,
              };
              _ctx.$emit('execute_link');
            } else if (__props.element.linkType == 'event') {
              _unref(store).state.event = {
                event: castEventStringIcon(props.element.content).event,
                data: castEventStringIcon(props.element.content).data,
              };
              _ctx.$emit('signal_event');
            }
          }
        ),
                                class: _normalizeClass(actual_classes.button)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    ios: castStringIcon(__props.element.content).icon.ios,
                                    md: castStringIcon(__props.element.content).icon.md,
                                    color: _unref(getIonicColor)(__props.element.colors?.text),
                                    class: _normalizeClass(actual_classes.icon)
                                  }, null, 8, ["ios", "md", "color", "class"])
                                ]),
                                _: 1
                              }, 8, ["disabled", "class"]),
                              (castStringIcon(__props.element.content).order)
                                ? (_openBlock(), _createBlock(_unref(IonLabel), {
                                    key: 1,
                                    color: _unref(getIonicColor)(__props.element.colors?.text),
                                    class: _normalizeClass(actual_classes.label)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(castStringIcon(__props.element.content).text), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color", "class"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["lines", "color", "class"]))
                        : _createCommentVNode("", true)
                ], 64))
  ], 64))
}
}

})